import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class SanityService {
  constructor(private http: HttpClient) {}

  fetch<T>(query: string, params?: Record<string, string>): Observable<T> {
    let httpParams = new HttpParams().set('query', query);
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        httpParams = httpParams.set(`$${key}`, value);
      });
    }
    return this.http
      .get<{ result: T }>(environment.BACKEND_SERVER_URL + '/sanity/query', {
        params: httpParams,
        withCredentials: true,
      })
      .pipe(map(res => res.result));
  }
}
